import { render } from "./EventSidebar.vue?vue&type=template&id=7df3d2cc&scoped=true"
import script from "./EventSidebar.vue?vue&type=script&lang=js"
export * from "./EventSidebar.vue?vue&type=script&lang=js"

import "./EventSidebar.vue?vue&type=style&index=0&id=7df3d2cc&scoped=true&lang=css"

import exportComponent from "../../../../../../../name-pronunciation/orator-pro-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7df3d2cc"]])

export default __exports__